module.exports = __webpack_public_path__ + "img/TipperRoof_Overview-E-Drive.482a3783.jpg";